import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 34 27"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M34 .604c0 .563-.765 1.328-2.294 2.294-3.945 2.575-6.641 5.473-8.09 8.693-.724 1.61-1.087 3.059-1.087 4.346 0 2.013.483 3.019 1.45 3.019.482 0 1.166-.724 2.052-2.173.644-.886 1.69-1.329 3.139-1.329 2.898 0 4.347 1.57 4.347 4.71 0 1.77-.685 3.3-2.053 4.587-1.368 1.288-3.018 1.932-4.95 1.932-2.254 0-4.105-.765-5.554-2.294-1.449-1.61-2.174-3.622-2.174-6.037 0-5.232 2.697-10.182 8.09-14.85.724-.645 1.892-1.369 3.501-2.174C31.987.443 32.993 0 33.396 0c.402 0 .603.201.603.604Zm-18.594 0c0 .563-.765 1.328-2.294 2.294-3.944 2.575-6.64 5.473-8.09 8.693-.724 1.61-1.086 3.099-1.086 4.467 0 1.932.483 2.898 1.449 2.898.483 0 1.167-.724 2.052-2.173.644-.886 1.65-1.329 3.019-1.329 2.978 0 4.467 1.57 4.467 4.71 0 1.85-.684 3.42-2.053 4.708-1.287 1.207-2.938 1.811-4.95 1.811-2.254 0-4.105-.765-5.554-2.294C.917 22.78.193 20.767.193 18.352c0-5.151 2.696-10.061 8.09-14.73.724-.644 1.89-1.408 3.5-2.294C13.394.443 14.4 0 14.804 0c.402 0 .603.201.603.604Z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }